import "antd/es/space/style";
import _Space from "antd/es/space";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext } from 'react';
import FieldContext from '../../FieldContext';
import './index.less';
var Group = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useContext = React.useContext(FieldContext),
      groupProps = _React$useContext.groupProps;

  var _groupProps$props = _objectSpread(_objectSpread({}, groupProps), props),
      children = _groupProps$props.children,
      style = _groupProps$props.style,
      title = _groupProps$props.title,
      _groupProps$props$siz = _groupProps$props.size,
      size = _groupProps$props$siz === void 0 ? 32 : _groupProps$props$siz,
      titleStyle = _groupProps$props.titleStyle,
      titleRender = _groupProps$props.titleRender;

  var _useContext = useContext(_ConfigProvider.ConfigContext),
      getPrefixCls = _useContext.getPrefixCls;

  var className = getPrefixCls('pro-form-group');
  var titleDom = titleRender ? titleRender(title, props) : title;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style,
    ref: ref
  }, titleDom && /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, "-title"),
    style: titleStyle
  }, titleDom), /*#__PURE__*/React.createElement(_Space, {
    className: "".concat(className, "-container"),
    size: size
  }, children));
});
Group.displayName = 'ProForm-Group';
export default Group;